import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { AgencyService } from "../../../service/AgencyService";
import AddAgencyBalanceRequest from "../../../model/agency/balance/AddAgencyBalanceRequest";
import PaymentMethod from "../../../entities/PaymentMethod";

class AddAgencyBalanceStore {

    public agencyId: string;
    public amount?: number;
    public paymentMethod?: PaymentMethod;
    public comment?: string;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;
    public amountError?: string;
    public toError?: string;
    public error?: string;
    public success?: string;


    constructor(commonStore: CommonStore, agencyId: string, value: number) {
        this.amount = value;
        this.agencyId = agencyId;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    get enableButton(): boolean {
        return !!(this.amount);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async cleanModal() {
        this.amount = undefined;
        this.comment = undefined;
    }


    @action
    public async save(): Promise<boolean> {
        if (this.amount) {
            this.loading = true;
            const request = new AddAgencyBalanceRequest(this.amount, this.paymentMethod, this.comment);
            const response = await AgencyService.addBalance(this.agencyId, request);
            this.commonStore.processErrors(response);
            this.loading = false;
            return response.success;
        } else {
            this.amountError = undefined;
        }
        return false;
    }
}

export default AddAgencyBalanceStore;